<template>
    <relatorio-page :titulo=" 'Detalhar Compromisso - Código ' + id " :cabecalhoCompleto="true" :exportarExcel="false" :paisagem="false">
        <div v-if="item.id > 0">
            <v-row>
                <v-col md="6">
                    <span style="font-weight: bold">Plano de Conta: </span>
                    <span>{{planoConta.nome}}</span>
                </v-col>
                <v-col md="6">
                    <span style="font-weight: bold">Plano de Conta (Item): </span>
                    <span>{{planoContaItem.nome}}</span>
                </v-col>
            </v-row>
            <v-row>
                <v-col md="6">
                    <span style="font-weight: bold">Banco: </span>
                    <span>{{banco.id > 0 ? banco.codigoNome : ""}}</span>                    
                </v-col>
                <v-col md="6">
                    <span style="font-weight: bold">Descrição: </span>
                    <span>{{item.descricao}}</span>
                </v-col>                
            </v-row>
            <v-row>
                <v-col md="6">
                    <span style="font-weight: bold">Fornecedor: </span>
                    <span>{{item.fornecedor.nome}}</span>
                </v-col>
                <v-col md="6">
                    <span style="font-weight: bold">Projeto: </span>
                    <span>{{item.projeto.codigoNome}}</span>
                </v-col>
            </v-row>
            <v-row>
                <v-col md="6">
                    <span style="font-weight: bold">Atividade: </span>
                    <span>{{atividade.nome}}</span>
                </v-col>
                <v-col md="6">
                    <span style="font-weight: bold">Sub Atividade: </span>
                    <span>{{subAtividade.nome}}</span>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="6" md="6">
                    <span style="font-weight: bold">Lançamento: </span>
                    <span>{{item.dataLancamento ? new Date(item.dataLancamento).ddmmyyyy() : ""}}</span>
                </v-col>
                <v-col cols="6" md="6">
                    <span style="font-weight: bold">Emissão: </span>
                    <span>{{item.dataEmissao? new Date(item.dataEmissao).ddmmyyyy() : ""}}</span>
                </v-col>
                <v-col cols="6" md="6">
                    <span style="font-weight: bold">Competência: </span>
                    <span>{{item.dataCompetencia ? new Date(item.dataCompetencia).ddmmyyyy() : ""}}</span>
                </v-col>
                <v-col cols="6" md="6">
                    <span style="font-weight: bold">Vencimento: </span>
                    <span>{{item.dataVencimento ? new Date(item.dataVencimento).ddmmyyyy() : ""}}</span>
                </v-col>
                <v-col cols="6" md="6">
                    <span style="font-weight: bold">Pagamento: </span>
                    <span>{{item.dataPagamento ? new Date(item.dataPagamento).ddmmyyyy() : ""}}</span>
                </v-col>
            </v-row>
            <v-row>
                <v-col md="5">
                    <span style="font-weight: bold">Forma de pagamento: </span>
                    <span>{{item.formaPagamentoStr}}</span>
                </v-col>
                <v-col md="3">
                    <span style="font-weight: bold">Situacao: </span>
                    <span>{{item.situacaoStr}}</span>
                </v-col>
                <v-col md="4">
                    <span style="font-weight: bold">Valor: </span>
                    <span>{{item.valor.toMoeda(true)}}</span>
                </v-col>
            </v-row>
            <v-row>
                <v-col md="5">
                    <span style="font-weight: bold">Desconto: </span>
                    <span>{{item.desconto.toMoeda(true)}}</span>
                </v-col>
                <v-col md="3">
                    <span style="font-weight: bold">Juros: </span>
                    <span>{{item.juros.toMoeda(true)}}</span>
                </v-col>
                <v-col md="4">
                    <span style="font-weight: bold">Valor Final: </span>
                    <span>{{item.valorFinal.toMoeda(true)}}</span>
                </v-col>
            </v-row>
            <v-row>
                <v-col md="6">
                    <span style="font-weight: bold">Número Documento: </span>
                    <span>{{item.numeroDocumento}}</span>
                </v-col>
                <v-col md="6">
                    <span style="font-weight: bold">Recorrência (Meses): </span>
                    <span>{{item.recorrencia}}</span>
                </v-col>
            </v-row>
            <fieldset class="pa-2 mt-2">
                <legend>Observação</legend>
                <v-row>
                    <v-col md="12">
                        <span>{{item.observacao}}</span>
                    </v-col>
                </v-row>
            </fieldset>
        </div>

        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

    </relatorio-page>
</template>

<script>

import CompromissoService from '@/core/services/financeiro/CompromissoService';
import Compromisso from '@/core/domain/financeiro/Compromisso';
import BancoService from '@/core/services/financeiro/BancoService';
import Banco from '@/core/domain/financeiro/Banco';
import PlanoContaService from '@/core/services/financeiro/PlanoContaService';
import PlanoConta from '@/core/domain/financeiro/PlanoConta';
import PlanoContaItem from '@/core/domain/financeiro/PlanoContaItem';
import Atividade from '../../../core/domain/projetos/Atividade';
import AtividadeItem from '../../../core/domain/projetos/AtividadeItem';


export default {
    
    data: () => ({
        id: 0,
        item: new Compromisso(),
        banco: new Banco(),
        planoConta: new PlanoConta(),
        planoContaItem: new PlanoContaItem(),
        atividade: new Atividade(),
        subAtividade: new AtividadeItem(),
        overlay: false
    }),
    props:{
        
    },
    mounted(){
        this.id = this.$route.params.id
        this.Carregar();
    },
    methods:{
        Carregar(){
            const service = new CompromissoService();
            const bancoService = new BancoService();
            const planoContaService = new PlanoContaService();

            this.overlay = true;
            service.ObterPorId(this.id, "Fornecedor, Projeto.Atividades.Itens").then(
                res=>{
                    this.item = res.data;

                    var projeto = this.item.projeto;
                    this.atividade = projeto.atividades.find(x => x.id == this.item.atividadeId)
                    this.subAtividade = this.atividade.itens.find(x => x.id == this.item.atividadeItemId)

                    bancoService.ObterPorId(this.item.bancoId).then(
                        res => {
                            this.banco = res.data
                        }
                    )
                    planoContaService.ObterPorId(this.item.planoContaId, "Itens").then(
                        res => {
                            this.planoConta = res.data
                            this.planoContaItem = this.planoConta.itens.find(x => x.id == this.item.planoContaItemId);
                        }
                    )
                },
                err=>{
                    this.$swal('Aviso', err.response.data, 'error')
                }
            ).finally(() => {
                this.overlay = false;
            })
        }
    }   

}
</script>

<style>

.fonte{
  font-size: 80%;
}

</style>
